// Webpack Imports
import * as bootstrap from 'bootstrap';
import './product-filters';
window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

( function () {
	'use strict';

	// Focus input if Searchform is empty
	[].forEach.call( document.querySelectorAll( '.search-form' ), ( el ) => {
		el.addEventListener( 'submit', function ( e ) {
			var search = el.querySelector( 'input' );
			if ( search.value.length < 1 ) {
				e.preventDefault();
				search.focus();
			}
		} );
	} );

	// Initialize Popovers: https://getbootstrap.com/docs/5.0/components/popovers
	var popoverTriggerList = [].slice.call( document.querySelectorAll( '[data-bs-toggle="popover"]' ) );
	var popoverList = popoverTriggerList.map( function ( popoverTriggerEl ) {
		return new bootstrap.Popover( popoverTriggerEl, {
			trigger: 'focus',
		} );
	} );

	// Mega menu dropdowns must not use Popper. A Popper transform creates a new
	// CSS containing block, which breaks sub-menu absolute positioning (left:100%).
	// Eagerly initialising with display:'static' prevents the inline transform
	// before any click can trigger Bootstrap's default Popper-based init.
	[].slice.call( document.querySelectorAll( '.navbar-nav.mega-menu [data-bs-toggle="dropdown"]' ) ).forEach( function ( el ) {
		new bootstrap.Dropdown( el, { display: 'static' } );
	} );

	function delay(fn, ms = 500) {
		let timer = 0
		return function(...args) {
			clearTimeout(timer)
			timer = setTimeout(fn.bind(this, ...args), ms || 0)
		}
	}
	
	// Debounced keyup listener (unchanged)
	// Multi-instance keyup handler
	$(document).on('keyup', '[data-autocomplete-true] input', delay(function (e) {
		liveSearch($(this)); // pass the input element
	}, 500));


	// Show skeleton results for THIS instance
	function showSkeletonResults($wrapper, count = 5) {

		let html = '<ul class="search__results search__results--loading">';

		for (let i = 0; i < count; i++) {
			html += `
				<li class="item-result result--product is-skeleton">
					<a href="javascript:void(0);" tabindex="-1">
						<div class="thumbnail skeleton-box"></div>
						<div class="title">
							<span class="skeleton-line skeleton-line--title"></span>
							<span class="skeleton-line skeleton-line--price"></span>
						</div>
					</a>
				</li>
			`;
		}

		html += '</ul>';

		$wrapper.html(html).stop(true, true).fadeIn(150);
	}


	// Clear results for THIS instance
	function clearResults($wrapper) {
		$wrapper.stop(true, true).fadeOut(150, function () {
			$(this).empty();
		});
	}


	// Perform search for THIS input instance
	function liveSearch($input) {

		if (!$input.data('live')) return;

		const value = $input.val();
		const $wrapper = $input.closest('[data-autocomplete-true]').find('.search__results-wrapper');

		// If < 3 chars → hide this instance only
		if (!value || value.length < 3) {
			clearResults($wrapper);
			return;
		}

		const url = '/wp-json/konstruct/v1/search_preview';

		// Show skeletons for this instance
		showSkeletonResults($wrapper, 5);

		window.axios.get(url, {
			params: { s: value }
		})
		.then(response => {
			$wrapper.html(response.data.results);
		})
		.catch(error => {
			console.log('error', error);
			$wrapper.html(`
				<ul class="search__results">
					<li>Something went wrong. Please try again.</li>
				</ul>
			`);
		})
		.finally(() => {
			$wrapper.fadeIn(200);
		});
	}


	// Clicking outside hides ALL search result wrappers
	$(document).on('click', function (e) {
		$('[data-autocomplete-true]').each(function () {
			let $container = $(this);
			if (!$container.is(e.target) && $container.has(e.target).length === 0) {
				$container.find('.search__results-wrapper').hide();
			}
		});
	});


	// Focus on input → show only THAT dropdown
	$(document).on('focus', '[data-autocomplete-true] input', function () {
		let $container = $(this).closest('[data-autocomplete-true]');

		$('.search__results-wrapper').hide(); // hide all other instances
		$container.find('.search__results-wrapper').show();
	});

	$(document).on('click', '.search_form--mobile-icon-toggle', function(e) {
		e.preventDefault();

		$('.search_form--mobile-toggle').toggle();
	});


	$(document.body).on('click', '.quantity-counter .increment', function() {
		
		// Enhances number input adding increment buttons
		let dir = $(this).attr('direction')
		let input = $(this).closest('.quantity-counter').find('input')[0]
		let value = input.value

		if(dir =='up')  {
			value++
		}

		if(dir =='down')  {
			if(value > 1) {
				value--
			}
		}

		input.value = value
		$(input).trigger('change')
	})

	let floatingCart = {

		toastFragments(fragments) {

			Object.entries(fragments).forEach(([type, notices]) => {

				notices.forEach(({ notice }) => {

					Toastify({
						text: notice,
						duration: 2500,
						close: false,
						gravity: "bottom",
						position: "center",
						stopOnFocus: true,
						className: `alert ${type}`, 
						escapeMarkup: false
					}).showToast();

				});
			});
		},
		refreshFragments(fragments){

			$.each(fragments, (key, value) => { 
				$(key).replaceWith(value)
			} );

			floatingCart.toastFragments(fragments['woocommerce-notices-object'] ?? {})

		},
		el: $('.floating-cart'),
		init(){
			$(document.body).on('click', '.floating-cart-close-button', () => this.close() )
			$(document.body).on('click', '.floating-cart-open-button', () => this.open() )
			$(document.body).on('click', '.floating-cart-toggle-button', () => this.toggle() )
			$(document.body).on('change', '.floating-cart .quantity-input', this.updateQuantity)
			$( document ).ajaxSuccess( floatingCart.removeInterceptor )
		},
		updateQuantity: delay( async(el) => {

			let $input = el.target
			let key = $input.getAttribute('cart-key')
			let quantity = $input.value
			floatingCart.busy()
			let res = await $.post('?wc-ajax=cart/update-quantity', {
				key, 
				quantity
			})

			floatingCart.refreshFragments(res.fragments)
			floatingCart.ready()
			$(document.body).trigger('wc_updated_qty')
		}),
		toggle(){
			if( this.el.length == 0 ) {
				window.location = "/cart"
			}
			this.el.hasClass('open') ? this.close() : this.open()
		},
		ready() {
			this.el.removeClass('busy')
		},
		busy(){
			this.el.addClass('busy')
		},
		removeInterceptor: function(event, xhr, settings){
			
			if ( !settings.url.includes('wc-ajax=remove_from_cart') ) {
				return
			} 

			const response = xhr.responseJSON;

			if (!response?.fragments) {
				return
			}

			floatingCart.toastFragments( response.fragments['woocommerce-notices-object'] ?? {} )

		},
		interceptor: function (event, xhr, settings) {
			
			if ( !settings.url.includes('wc-ajax=get_refreshed_fragments') ) {
				return
			}

			const response = xhr.responseJSON;

			if (!response?.fragments) {
				return
			}

			floatingCart.toastFragments( response.fragments['woocommerce-notices-object'] ?? {} )

			$(document).off('ajaxSuccess', floatingCart.interceptor)

		},
		refresh( cb = () => {} ){
			this.busy()
			/**
				Take a CB fn that is fired once event concludes.
				Binds temporary fn to apply logic
			*/
			
			let fn = (e, fragments) => {
				$( document.body ).off( 'wc_fragments_refreshed', fn)	
				cb()
				this.ready()
			}

			/**
				Intercept ajax request so we can manually trigger fragments for toast
			*/
			$( document ).ajaxSuccess( floatingCart.interceptor )
			$( document.body ).on( 'wc_fragments_refreshed', fn)
			$( document.body ).trigger( 'wc_fragment_refresh' )
		},
		open() {
			if( this.el.length == 0 ) {
				return;
			}
			this.el.addClass('open')
			$('body').addClass('noscroll');
		},
		_close(){
			this.el.removeClass('open');
			$('body').removeClass('noscroll');
		},
		close(delay = 0){
			setTimeout(() => this._close(), delay)
		}
	}
	floatingCart.init();

	$(document).on('submit','form.cart', function(e){
		e.preventDefault()
		submitForm( new FormData(e.target) )
	});

	let submitForm = async(data) => {
		
		$('form.cart').addClass('loading');

		$('form.cart .loading-container').attr('loading', true);

		data.append('action', 'woo-product-add-to-cart');

		let res = await $.ajax({
            type: 'POST',
            url: fweb.ajax_url,
			processData: false,
			contentType: false,
            data,
        });

		let response = JSON.parse(res)
		
		$('form.cart').removeClass('loading');

		$('form.cart .loading-container').attr('loading', false);

		if(response.valid) {
			floatingCart.open()
			floatingCart.refresh( () => floatingCart.close(2000) )
		}
	}

	let fauxVariations = () => {
		let bindEl = $el => {	

			let data = {
				get $value(){
					/**
						Value is the current value of the $select element
					*/
					return data.$select.value
				},
				get $select(){
					/**
						$Select is the target woo select this is bound to
					*/
					return document.querySelector(`select[data-attribute_name='attribute_${data.attribute_name}']`)
				},
				get attribute_name() {
					return $el.getAttribute('data-attribute_name')
				},
				get attribute_value(){
					return $el.getAttribute('data-attribute_value')
				},
				click(){
					$(data.$select)
						.val(data.attribute_value)
						.trigger('change')
				},
				validateIsAvailable(){
					let validValues = Array.from(data.$select.options)
						.map(e => {
							return e.value
						})
					if( !validValues.includes(data.attribute_value) ) {
						return $el.classList.add('disabled')
					}
					$el.classList.remove('disabled')
				},
				inputChange(){
					
					data.validateIsAvailable()
					let { 
						$value,
						attribute_value
					} = data

					data.setOff()

					if($value == '') return;
					if($value == attribute_value) data.setOn()
					
				},
				setOn(){
					$el.classList.add('active')
				},
				setOff() {
					$el.classList.remove('active')
				}
			}
			$el.addEventListener('click', data.click)
			$(data.$select).on('change', data.inputChange)
			/**
				firing to init it.
			*/
			data.inputChange()
			return data;
		}

		let variations = $('.faux-variation-button');

		let elements = variations.map((k, $el) => bindEl($el) )
		

		let revalidateOptions = () => {
			/**
				"Debouncing" so the input events have time to trigger before checking
			*/
			setTimeout(() =>  elements.map( (k, $el) => $el.validateIsAvailable() ), 1);
		}

		$('select[data-attribute_name]').each((k, e) => $(e).on('change', revalidateOptions ) )
		
	}

	fauxVariations();
	

} )();

jQuery(function() { 
	jQuery.navigation.init();
});

jQuery(window).on('resize', (function() {
	return function(e) {
		jQuery.navigation.repositionDropdowns();
	};
})());

(function ( $ ) {
	$.navigation = {
		/**
		 * Initialize navigation.
		 */
		'init': function () {
			this.handleResponsiveDropdowns();
			this.handleTouchDropdowns();
			this.repositionDropdowns();
			this.activeParentLink();
			this.handleSubDropdownDirection();
		},

		/**
		 * Handles dropdowns on touch devices.
		 * @returns {boolean}
		 */
		'handleTouchDropdowns': function () {
			var windowWidth = window.innerWidth;
			if ( windowWidth < 991 ) {
				return false;
			}

			var self = this;
			$( '.caret-wrap' ).on( 'touchstart', function ( e ) {
				e.preventDefault();
				e.stopPropagation();
				var menuItem = $( this ).closest( 'li' );
				if ( $( menuItem ).hasClass( 'dropdown-submenu' ) ) {
					$( menuItem ).siblings().removeClass( 'open' ).find( 'dropdown-submenu' ).removeClass( 'open' );
					$( menuItem ).siblings().find( '.caret-open' ).removeClass( 'caret-open' );
				}
				if ( $( this ).closest( 'li' ).parent().is( '.nav' ) ) {
					self.clearDropdowns();
				}
				$( this ).toggleClass( 'caret-open' );
				$( this ).closest( '.dropdown' ).toggleClass( 'open' );
			} );
			return false;
		},

		'clearDropdowns': function () {
			$( '.dropdown.open' ).removeClass( 'open' );
			$( '.caret-wrap.caret-open' ).removeClass( 'caret-open' );
		},

		/**
		 * Handle the responsive menus under 769px.
		 */
		'handleResponsiveDropdowns': function () {
			var windowWidth = window.innerWidth;
			if ( windowWidth > 768 ) {
				return false;
			}
			$( '.navbar .dropdown > a .caret-wrap' ).on( 'click touchend',
				function ( event ) {
					var caret = $( this );
					event.preventDefault();
					event.stopPropagation();
					//Change caret wrap.
					$( caret ).toggleClass( 'caret-open' );
					//Open dropdown.
					$( caret ).parent().siblings().toggleClass( 'open' );
				}
			);
		},

		/**
		 * Add active parent links on navigation
		 */
		'activeParentLink': function () {
			$(document).on('click', '.navbar-nav .dropdown > a', function() {
				if ( $( this ).attr( 'href' ) === '#' ) {
					return false;
				}
				location.href = this.href;
				return false;
			})
		},

		/**
		 * On hover of any .dropend item, decide direction synchronously before
		 * CSS makes the child menu visible — avoids the flash-then-flip that
		 * requestAnimationFrame causes, and prevents transient horizontal scroll.
		 * Measures the parent element (always visible) rather than the hidden menu.
		 */
		'handleSubDropdownDirection': function () {
			$( document ).on( 'mouseenter', '.dropend', function () {
				var $menu = $( this ).children( '.dropdown-menu' );
				if ( ! $menu.length ) return;

				var rect       = this.getBoundingClientRect();
				var menuWidth  = parseFloat( $menu.css( 'min-width' ) ) || 220;

				if ( rect.right + menuWidth > window.innerWidth ) {
					$menu.css( { left: 'auto', right: '100%' } );
				} else {
					$menu.css( { left: '100%', right: 'auto' } );
				}
			} );
		},

		/**
		 * Reposition dropdowns if they are out of screen.
		 * @returns {boolean}
		 */
		'repositionDropdowns': function () {
			var windowWidth = window.innerWidth;
			//Do nothing on mobile.
			if ( windowWidth <= 768 ) {
				return false;
			}
			//Do nothing without dropdowns.
			var dropdowns = $( '.dropdown-menu' );
			if ( dropdowns.length === 0 ) {
				return false;
			}
			//Loop dropdowns and move them if needed.
			$.each( dropdowns, function ( key, dropdown ) {
				var submenu = $( dropdown );
				var bounding = submenu.offset().left;
				if ( /webkit.*mobile/i.test( navigator.userAgent ) ) {
					bounding -= window.scrollX;
				}
				var dropdownWidth = submenu.outerWidth();
				if ( bounding + dropdownWidth >= windowWidth ) {
					$( dropdown ).css( { 'right': '100%', 'left': 'auto' } );
				}
			} );
			return false;
		}
	};
} )( jQuery );

// jQuery(function ($) {
//     $('form.variations_form').on('found_variation', function (event, variation) {
//         let variationId = variation.variation_id;

//         $.ajax({
//             url: wc_add_to_cart_params.ajax_url,
//             type: 'POST',
//             data: {
//                 action: 'get_variation_gallery',
//                 variation_id: variationId
//             },
//             success: function (response) {
//                 if (response.success && response.data.length > 0) {
//                     let galleryHtml = '';
//                     response.data.forEach(function (url) {
//                         galleryHtml += '<img src="' + url + '" class="variation-gallery-image" style="max-width:100px;margin:5px" />';
//                     });
//                     $('#variation-gallery').html(galleryHtml);
//                 } else {
//                     $('#variation-gallery').empty();
//                 }
//             }
//         });
//     });
// });

// jQuery(function ($) {
//     $('form.variations_form').on('found_variation', function (event, variation) {
//         const variationId = variation.variation_id;

//         $.post({
//             url: wc_add_to_cart_params.ajax_url,
//             data: {
//                 action: 'get_variation_gallery',
//                 variation_id: variationId
//             },
//             success: function (response) {
//                 if (response.success) {
//                     const $gallery = $('.woocommerce-product-gallery__wrapper');
//                     const $mainImage = $('.woocommerce-product-gallery__image:first-child a');

//                     const images = response.data;

//                     if (images.length) {
//                         // Replace main image
//                         const first = images[0];
// 						console.log('first image: ', first);
                        
// 						$mainImage.attr('href', first.full);
//                         $mainImage.find('img').attr({
//                             src: first.full,
//                             srcset: first.srcset || '',
//                             alt: first.alt || ''
//                         });

// 						console.log('main image: ', $mainImage);

//                         // Replace thumbnails
//                         $gallery.empty();

//                         images.forEach(function (img) {
//                             const html = `
//                                 <div class="woocommerce-product-gallery__image">
//                                     <a href="${img.full}">
//                                         <img src="${img.thumb}" alt="${img.alt}" />
//                                     </a>
//                                 </div>`;
//                             $gallery.append(html);
//                         });

//                         // Re-init zoom/lightbox
//                         if (typeof $.fn.zoom === 'function') {
//                             $('.woocommerce-product-gallery__image').zoom(); // or whatever your theme uses
//                         }

//                         if (typeof wc_single_product_gallery !== 'undefined') {
//                             wc_single_product_gallery.init(); // reinit if needed
//                         }
//                     }
//                 }
//             }
//         });
//     });
// });

// jQuery(function ($) {
//     $('form.variations_form').on('found_variation', function (event, variation) {
//         const variationId = variation.variation_id;

//         $.post({
//             url: wc_add_to_cart_params.ajax_url,
//             data: {
//                 action: 'get_variation_gallery',
//                 variation_id: variationId
//             },
//             success: function (response) {
//                 if (!response.success || !response.data.length) return;

//                 const images = response.data;
//                 const $gallery = $('.woocommerce-product-gallery');
//                 const $wrapper = $gallery.find('.woocommerce-product-gallery__wrapper');

//                 // Clear existing slides
//                 $wrapper.empty();

//                 // Add new gallery slides
//                 images.forEach(function (img) {
//                     const slide = `
//                         <div class="woocommerce-product-gallery__image" data-thumb="${img.thumb}">
//                             <a href="${img.full}" data-elementor-lightbox-slideshow="default">
//                                 <img 
//                                     src="${img.thumb}"
//                                     data-large_image="${img.full}"
//                                     data-large_image_width="${img.width}" 
//                                     data-large_image_height="${img.height}" 
//                                     alt="${img.alt}" 
//                                     srcset="${img.srcset}" 
//                                     sizes="${img.sizes}" />
//                             </a>
//                         </div>`;
//                     $wrapper.append(slide);
//                 });

// 				if (typeof elementorFrontend !== 'undefined' && elementorFrontend.lightbox) {
// 					elementorFrontend.lightbox.init();
// 				}
//             }
//         });
//     });
// });
